import React, { useEffect } from 'react';
import { CollapseBlock, Spinner } from '../../../../common';
import {
  useGetUsefulLinkQuery,
  useGetUsefulLinksQuery,
  useSaveUsefulLinkMutation,
} from '../../../../../redux/services/useful_links.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import UsefulLinkForm from './UsefulLinkForm.jsx';
import { AppBarCMS } from '../../../../basic';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useToastMessages } from '../../../../../hooks/useToastMessages';

const UsefulLinksEdit = ({ mode }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const isCreate = mode === 'create';
  const isEdit = mode === 'edit';

  useEffect(() => {
    document.title = isEdit
      ? t('Úprava užitočného odkazu') + ' - FRI CMS'
      : t('Pridanie užitočného odkazu') + ' - FRI CMS';
  }, []); // Runs on mount

  const { saveSuccess } = useToastMessages();

  const { data: linkDetail, isLoading } = useGetUsefulLinkQuery(id, {
    skip: !isEdit,
  });

  const [saveUsefulLink, { isSuccess: isSaveSuccess }] =
    useSaveUsefulLinkMutation();

  const { refetch } = useGetUsefulLinksQuery();

  useEffect(() => {
    if (isSaveSuccess) {
      saveSuccess();
      navigate(routes.cmsUsefulLinks);
      refetch();
    }
  }, [isSaveSuccess]);

  const title = isCreate
    ? t('Pridanie užitočného odkazu')
    : t('Úprava užitočného odkazu');

  if (isEdit && isLoading) {
    return <Spinner />;
  }

  const initials = {
    title: undefined,
    title_en: undefined,
    url: undefined,
    url_en: undefined,
    visible: true,
    new: false,
    ...linkDetail,
  };

  return (
    <>
      <AppBarCMS
        title={title}
        backUrl={routes.cmsUsefulLinks}
        backUrlTooltip={t('Užitočné odkazy')}
        permissionsBasic="useful-links"
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock title={t('Obsah')}>
          <UsefulLinkForm
            initials={initials}
            onSubmit={(values) => {
              saveUsefulLink({ body: values, id });
            }}
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default UsefulLinksEdit;
